<!-- Страница навигации раздела администрирования -->
<template>
    <navigation :caption="caption" :menu-items="menuItems" />
</template>

<script>
import Vue from 'vue';
import Navigation from '@/components/Navigation/Navigation.vue';

export default Vue.extend({
    name: 'NavigationAdmin',
    components: {
        Navigation,
    },
    data() {
        return {
            menuItems: [
                {
                    to: '/administration/devices',
                    title: 'Устройства',
                    description: 'Устройства, принимающие данные',
                    componentName: 'b-icon-diagram3-fill',
                },
                {
                    to: '/administration/indicators',
                    title: 'Показатели',
                    description: 'Показатели устройств',
                    componentName: 'b-icon-pencil-square',
                },
                {
                    to: '/administration/users',
                    title: 'Пользователи',
                    description: 'Пользователи приложения',
                    componentName: 'b-icon-people-fill',
                }
            ],
            caption: 'Администрирование',
        };
    },
    metaInfo: {
        title: 'Администрирование системы',
    },
});
</script>
